/* @flow */

import * as React from 'react';
import useSheet from 'app/jss';

import Icon from 'app/components/commons/Icon';
import styled from '@emotion/styled';

type Props = {
  children: any,
  classes: Object,
  icon: string,
  onClick: () => void
};

const Wrapper = styled.div({
  cursor: 'pointer'
});

class CampaignButton extends React.PureComponent {
  props: Props;

  render() {
    const { children, classes, icon, onClick } = this.props;
    return (
      <Wrapper className={classes.primaryNavRow} onClick={onClick}>
        <div className={classes.primaryNavItem}>
          <div className={classes.icon}>
            <Icon type={icon} />
          </div>
          <span className={classes.primaryNavItem_Title}>{children}</span>
        </div>
      </Wrapper>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    primaryNavRow: {
      color: theme.color.white,
      width: '100%',
      position: 'relative',
      '&:last-child': {
        borderBottomWidth: 1
      }
    },
    primaryNavItem: {
      alignItems: 'center',
      borderLeft: '3px solid transparent',
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing.small,
      transition: 'all 0.2s',
      backgroundColor: theme.color.success
    },
    primaryNavItem_Title: {
      flexGrow: 1,
      fontSize: theme.fontSize.xsmall,
      fontWeight: theme.fontWeight.demiBold,
      paddingTop: 2
    },
    newPill: {
      lineHeight: 1.3,
      padding: [2, 4, 0, 4]
    },
    icon: {
      width: 20,
      height: 20,
      paddingRight: 5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
}

export default useSheet(applyStyles)(CampaignButton);
